import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule, Routes } from '@angular/router';

import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { NgApexchartsModule } from 'ng-apexcharts';

import { MatGridListModule } from '@angular/material/grid-list';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatToolbarModule } from '@angular/material/toolbar';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

/*  combined common modules into one file */
import { MatDatepickerModule } from '@angular/material/datepicker';
import { NgxMatTimepickerModule } from 'ngx-mat-timepicker';
import * as fromGuards from 'src/app/store/guards';
import { SharedModule } from '../../shared/shared.module';

// components & pages
import { ToggleComponent } from '../../shared/components/toggle/toggle.component';
import * as fromComponents from './components';
import * as fromContainers from './pages';

// date and time pickers

const orderRoutes: Routes = [
  {
    path: '',
    component: fromContainers.MetricTableComponent,
    canActivate: [fromGuards.DynamicAuthGuard, fromGuards.OrdersGuard],
  },
];

@NgModule({
  imports: [
    BrowserModule,
    SharedModule,
    BrowserAnimationsModule,
    MatButtonToggleModule,
    MatCheckboxModule,
    MatToolbarModule,
    MatSortModule,
    MatGridListModule,
    MatSlideToggleModule,
    FormsModule,
    ReactiveFormsModule,
    NgApexchartsModule,
    MatTableModule,
    MatPaginatorModule,
    RouterModule.forChild(orderRoutes),
    NgxMatTimepickerModule,
    MatDatepickerModule,
    ToggleComponent,
  ],
  declarations: [...fromComponents.components, ...fromContainers.containers],
  providers: [],
  exports: [...fromContainers.containers, ...fromComponents.components],
})
export class MetricDetailsModule {}
